import router from '../router'
import axios from 'axios'
import qs from 'qs'
import ElementUI from 'element-ui'

axios.defaults.withCredentials = true
let baseURL = process.env.NODE_ENV !== 'development' ? '/psc-ops-b/' : '/api/psc-ops-b/'

axios.defaults.baseURL = baseURL

// 请求拦截
axios.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// response拦截
axios.interceptors.response.use(
  response => {
    // code为401001，则跳转到登录页面
    if (response.data.code === 401001) {
      router.replace('/login')
      sessionStorage.removeItem('activeIndex');
      sessionStorage.removeItem('showMchid');
      return Promise.reject(new Error('401001'))
    }
    return response.data
  },
  error => {
    if (error.response) {
      if (error.response.status === 401001) {
        router.replace('/login')
        return Promise.reject(new Error('401001'))
      }
      return Promise.reject(error) // 返回错误信息
    }
  }
)

let http = {
  baseURL: baseURL,
  get: (url, params = {}, baseUrl) => {
    return axios.get(url, {
      params: params,
      baseURL: baseUrl || baseURL
    })
  },
  /**
     * POST请求
     * @param {String} url - 接口地址
     * @param {Object} params - 当为数组时，第一个为body值，第二个为query值
     * @param {String} contentType - json
     */
  post: (url, params = {}, baseUrl, newOpts = {}) => {
    let headers = {}
    const newHeaders = newOpts.headers || {}
    const options = {
      headers: {
        ...headers,
        ...newHeaders
      },
      method: 'POST',
      data: params,
      url: url,
      timeout: 1000 * 60 * 2,
      baseURL: baseUrl || baseURL,
      ...newOpts
    }
    return axios(options)
  },
  formDataPost: (url, params = {}, baseUrl) => {
    const options = {
      method: 'POST',
      data: qs.stringify(params),
      url: url,
      timeout: 1000 * 60 * 2,
      baseURL: baseUrl || baseURL
    }
    return axios(options)
  },
  // 获取文件流数据
  blobPost: (url, params = {}, baseUrl) => {
    const options = {
      method: 'POST',
      data: params,
      url: url,
      responseType: 'blob',
      baseURL: baseUrl || baseURL
    }
    return axios(options)
  },
  /**
     * 上传文件
     * @param {String} url - API地址
     * @param {FormData} formData 表单数据
     */
  upload: (url, params = {}, baseUrl) => {
    let headers = {
      'Content-Type': 'multipart/form-data'
    }
    if (params.unLoading) {
      headers = {
        unLoading: true,
        'Content-Type': 'multipart/form-data'
      }
      delete params.unLoading
    }
    const options = {
      headers,
      method: 'POST',
      data: params,
      url: url,
      baseURL: baseUrl || baseURL
    }
    return axios(options)
  },
  /**
     * 文件下载
     * @param {String} url
     * @param {Object} params
     */
  download: (url, params = {}, baseUrl) => {
    return new Promise((resolve, reject) => {
      let iframeId = `download-iframe-link`
      let iframe = document.getElementById(iframeId)
      if (!iframe) {
        iframe = document.createElement('iframe')
        iframe.id = iframeId
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
        iframe.onload = function () {
          // 导出异常的时候提示用户
          var result=JSON.parse(iframe.contentWindow.document.body.innerText);
          if(result && result.code!=0){
            resolve(result.msg)
          }else{
            resolve()
          }
          document.body.removeChild(iframe)
        }
        iframe.onerror = function () {
          reject(new Error(0))
          document.body.removeChild(iframe)
        }
      }
      let paramsString = qs.stringify(params)
      if (url.includes('http')) {
        iframe.src = url + (paramsString ? `?${paramsString}` : '')
      } else {
        console.log(`${baseUrl || baseURL}${url}?${paramsString}`)
        iframe.src = `${baseUrl || baseURL}${url}?${paramsString}`
      }
    })
  }
}

export default http



// WEBPACK FOOTER //
// ./src/api/http.js